import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleAmpedOutdoors30AhLiFePO4With3ACharger = () => {
  console.log('🎯 SimpleAmpedOutdoors30AhLiFePO4With3ACharger component loading');
  
  const product = findProductById("amped-30ah-lifepo4-with-charger");
  
  if (!product) {
    console.error('Product not found:', "amped-30ah-lifepo4-with-charger");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="amped-30ah-lifepo4-with-charger"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleAmpedOutdoors30AhLiFePO4With3ACharger; 